// extracted by mini-css-extract-plugin
export default {"overlay":"OverlayModal_overlay_BVlAV"};